import { IKnmListFilterRaw } from 'APIPackage/KnmListModule/interfaces/IKnmListFilterRaw';
import { IMspCategorySelectOption } from 'CorePackage/CatalogsModule/interfaces/IMspCategorySelectOption';
import { IRiskCategorySelectOption } from 'CorePackage/CatalogsModule/interfaces/IRiskCategorySelectOption';
import { IDictionarySupervisionTypeSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySupervisionTypeSelectOption';
import { IDictionarySubjectTypeSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySubjectTypeSelectOption';
import { IDictionarySubjectKindSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySubjectKindSelectOption';
import { IDictionarySubjectSubKindSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySubjectSubKindSelectOption';
import { IDictionaryKnmKindSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryKnmKindSelectOption';
import { IDictionaryEventTypeSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryEventTypeSelectOption';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';

import { knmListByPlanBooleanSelectOptions } from '../constants/knmListByPlanBooleanSelectOptions';
import { IKnmListByPlanFilter } from '../interfaces/IKnmListByPlanFilter';

export function mapRawToKnmListByPlanFilter(
  raw: IKnmListFilterRaw,
  riskCategoriesSelectOptions: IRiskCategorySelectOption[] | undefined,
  mspCategoriesSelectOptions: IMspCategorySelectOption[] | undefined,
  supervisionTypesSelectOptions: IDictionarySupervisionTypeSelectOption[] | undefined,
  objectTypesSelectOptions: IDictionarySubjectTypeSelectOption[] | undefined,
  objectKindsSelectOptions: IDictionarySubjectKindSelectOption[] | undefined,
  objectSubKindsSelectOptions: IDictionarySubjectSubKindSelectOption[] | undefined,
  knmKindsSelectOptions: IDictionaryKnmKindSelectOption[] | undefined,
  eventTypesSelectOptions: IDictionaryEventTypeSelectOption[] | undefined,
): IKnmListByPlanFilter {
  return {
    name: raw.name,
    riskCategory: raw.riskCategory?.reduce((r, x) => {
      const riskCategoryItem = riskCategoriesSelectOptions?.find(t => x === t.name);

      return riskCategoryItem ? [...r, riskCategoryItem] : [...r];
    }, []),
    reasonDateBetweenStart: raw?.reasonDateBetween?.[0]
      ? formatDate({ date: raw?.reasonDateBetween?.[0], dateFormat: DATE_FORMAT_LONG_FNS })
      : undefined,
    reasonDateBetweenEnd: raw?.reasonDateBetween?.[1]
      ? formatDate({ date: raw?.reasonDateBetween?.[1], dateFormat: DATE_FORMAT_LONG_FNS })
      : undefined,
    mspCategory: raw.mspCategory?.reduce((r, x) => {
      const mspCategoryItem = mspCategoriesSelectOptions?.find(t => x === t.title);

      return mspCategoryItem ? [...r, mspCategoryItem] : [...r];
    }, []),
    supervisionType: supervisionTypesSelectOptions?.find(option => option.id === raw.supervisionTypeId),
    objectsType: objectTypesSelectOptions?.find(option => option.title === raw.objectsType?.[0]),
    objectsKind: objectKindsSelectOptions?.find(option => option.title === raw.objectsKind?.[0]),
    objectsSubKind: objectSubKindsSelectOptions?.find(option => option.title === raw.objectsSubKind?.[0]),
    isHasRequirements:
      typeof raw.isHasRequirements === 'boolean'
        ? knmListByPlanBooleanSelectOptions.find(item => item.value === raw.isHasRequirements)
        : undefined,
    isHasApproveDocs:
      typeof raw.isHasApproveDocs === 'boolean'
        ? knmListByPlanBooleanSelectOptions.find(item => item.value === raw.isHasApproveDocs)
        : undefined,
    startDateBetweenStart: raw?.startDateBetween?.[0]
      ? formatDate({ date: raw?.startDateBetween?.[0], dateFormat: DATE_FORMAT_LONG_FNS })
      : undefined,
    startDateBetweenEnd: raw?.startDateBetween?.[1]
      ? formatDate({ date: raw?.startDateBetween?.[1], dateFormat: DATE_FORMAT_LONG_FNS })
      : undefined,
    kinds: knmKindsSelectOptions?.find(option => option.title === raw.kinds?.[0]),
    events: raw.events?.reduce((r, x) => {
      const eventsItem = eventTypesSelectOptions?.find(t => x === t.title);

      return eventsItem ? [...r, eventsItem] : [...r];
    }, []),
    isHasCollaboratingOrganization:
      typeof raw.isHasApproveDocs === 'boolean'
        ? knmListByPlanBooleanSelectOptions.find(item => item.value === raw.isHasApproveDocs)
        : undefined,
    signed: raw.signed !== undefined ? raw.signed : undefined,
  };
}
